import React, { Component } from 'react';
import '../../css/common/Input.css';

class Input extends Component {

  render() {

    var className   = this.props.className || 'input-default';
    var style       = this.props.style;
    var type        = this.props.type || 'text';
    var placeholder = this.props.placeholder || '';
    var value       = this.props.value || '';
    var onChange    = this.props.onChange;

    if (this.props.invalid === true) {
      className = className + ' input-invalid';
    }

    return <input className={className}
                  type={type}
                  style={style}
                  placeholder={placeholder}
                  value={value}
                  ref='input_ref'
                  onChange={onChange}
                />

  }

  focus = () => {
    this.refs.input_ref.focus();
  }

  blur = () => {
    this.refs.input_ref.blur();
  }

}

export default Input
